import { crudApi } from "../../../helpers/api_helper";
import { FORMA_PAGAMENTO } from "../../../helpers/url_helper";

export default crudApi(FORMA_PAGAMENTO);